import { RESPONSIVE_WIDTH_BREAKPOINT } from './constants'

export const getIsSmallScreen = (elementWidth: number): boolean =>
	elementWidth < RESPONSIVE_WIDTH_BREAKPOINT
